import { render, staticRenderFns } from "./Audio1.vue?vue&type=template&id=52dd4383&"
import script from "./Audio1.vue?vue&type=script&lang=js&"
export * from "./Audio1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports